import type { TFunction } from 'i18next';

/** Build Select options: value stays the enum/DB key, label is translated. */
export const enumOptions = <T extends string>(
    values: readonly T[],
    t: TFunction,
    keyPrefix: string,
): Array<{ value: T; label: string }> =>
    values.map((value) => ({
        value,
        label: t(`${keyPrefix}.${value}`, { defaultValue: value.replace(/_/g, ' ') }),
    }));

export const enumLabel = (t: TFunction, keyPrefix: string, value: string | null | undefined) => {
    if (!value) return '—';

    return t(`${keyPrefix}.${value}`, { defaultValue: value.replace(/_/g, ' ') });
};
